import React from 'react';

const PageInfo = ({ text }) => {
    return (
        <div className="page-info">
            <div className="page-info-text">
                {text}
            </div>
        </div>
    );
};

export default PageInfo;
